/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');
require('../plugins');

import Vue from 'vue';

import vueAwesomeCountdown from 'vue-awesome-countdown'
import VueTimeago from 'vue-timeago'
import merge from 'lodash.merge';
import orderby from 'lodash.orderby';
import numeral from 'numeral';
window.numeral = numeral;
window.Vue = Vue;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.use(vueAwesomeCountdown, 'vac')
Vue.use(VueTimeago, {
    name: 'Timeago', // Component name, `Timeago` by default
    locale: 'en', // Default locale
})

Vue.filter("formatNumber", function (value) {
    return numeral(value).format("0,0"); // displaying other groupings/separators is possible, look at the docs
});
Vue.filter("formatDollars", function (value) {
    if(value > 10000 && value % 100 === 0){
        return numeral(value / 100).format('$0,0'); // displaying other groupings/separators is possible, look at the docs
    }else{
        return numeral(value / 100).format('$0,0.00'); // displaying other groupings/separators is possible, look at the docs
    }
});
Vue.filter("formatDateTime", function (value) {
    return moment(value).format('MM/DD/YYYY hh:mm:ss A');
});
Vue.filter("formatDecimal", function (value) {
    return numeral(value).format("0,0.00"); // displaying other groupings/separators is possible, look at the docs
});
Vue.filter("formatDecimalNoGroup", function (value) {
    return numeral(value / 100).format("0.00"); 
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

if (window.__INITIAL_STATE__ !== undefined) {
    const app = new Vue({
        el: '#app',
        data: JSON.parse(window.__INITIAL_STATE__),
        methods: {
            getCsrfToken: function () {
                return document.querySelector('meta[name="csrf-token"]').content;
            },
        },
    });

    if (!!app.auctions) {
        const auctionIds = app.auctions.map(function (auction) { return auction.id; });
        getAuctionStatuses(auctionIds);
    }
}

window.merge = merge;

function getAuctionStatuses(auctionIds) {
    axios({
        method: 'post',
        url: '/auctions/statuses',
        data: auctionIds
    }).then(function (response) {
        var app = document.getElementById('app').__vue__;
        response.data.forEach(d => {
            var auction = app.auctions.filter(a => { return a.id == d.id });

            if (!!auction && !!auction[0]) {
                auction[0].status = d.status;
                auction[0].originalPrice = d.originalPrice;
                auction[0].currentPrice = d.currentPrice;
                auction[0].winningPrice = d.winningPrice;
                auction[0].winner = d.winner;
                auction[0].nextRoundAt = d.nextRoundAt;
                auction[0].roundTime = d.roundTime;
                auction[0].isWatchingAuction = d.isWatchingAuction;
            }
        });
        setTimeout(getAuctionStatuses, 2000, auctionIds);
    });
}